/**
 * Produces a JSON-serializable plain object for localStorage + API.
 * `File` entries are reduced to metadata (name, size, type); binary is not kept.
 */
export function serializeInfrastructureListingForm(form) {
  return JSON.parse(
    JSON.stringify(form, (key, value) => {
      if (value instanceof File) {
        return { __isFile: true, name: value.name, size: value.size, type: value.type };
      }
      if (value instanceof FileList) {
        return Array.from(value).map((f) => ({
          __isFile: true,
          name: f.name,
          size: f.size,
          type: f.type,
        }));
      }
      if (Array.isArray(value) && value.length && value[0] instanceof File) {
        return value.map((f) =>
          f instanceof File
            ? { __isFile: true, name: f.name, size: f.size, type: f.type }
            : f
        );
      }
      return value;
    })
  );
}
